import { useMemo } from "react";
import { useContent } from "src/shared/components/content";
import { TimeOfDayFilterOptions } from "src/shared/enums/enums";

export const useTimeFilterOptions = () => {
  const allTimesLabel = useContent("cid$#4247164#"); // "All Times"
  const daytimeLabel = useContent("cid$#3823288#"); // "Daytime"
  const eveningLabel = useContent("cid$#3823289#"); // "Evening"

  return useMemo(
    () => [
      { label: allTimesLabel, value: TimeOfDayFilterOptions.ALL },
      { label: daytimeLabel, value: TimeOfDayFilterOptions.DAYTIME },
      { label: eveningLabel, value: TimeOfDayFilterOptions.EVENING },
    ],
    [allTimesLabel, daytimeLabel, eveningLabel],
  );
};
